import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CelebrationIcon from "@mui/icons-material/Celebration";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import ChecklistIcon from "@mui/icons-material/Checklist";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import GavelIcon from "@mui/icons-material/Gavel";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import ImageIcon from "@mui/icons-material/Image";
import LinearScaleIcon from "@mui/icons-material/LinearScale";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import PinIcon from "@mui/icons-material/Pin";
import ShortTextIcon from "@mui/icons-material/ShortText";
import StarIcon from "@mui/icons-material/Star";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import {SvgIconComponent} from "@mui/icons-material";
import {SurveyQuestionType} from "crqlar-react-common/dist/models/survey/survey.model";
import React from "react";

const SURVEY_QUESTION_TYPE_COLORS: Record<SurveyQuestionType, string> = {
    [SurveyQuestionType.WELCOME]: '#4FD1C5',
    [SurveyQuestionType.GENERIC_SCORE]: '#F6AD55',
    [SurveyQuestionType.GENERIC_STARS]: '#F6AD55',
    [SurveyQuestionType.MULTIPLE_CHOICE]: '#D53F8C',
    [SurveyQuestionType.PICTURE_CHOICE]: '#805AD5',
    [SurveyQuestionType.DROPDOWN]: '#90CDF4',
    [SurveyQuestionType.YES_NO]: '#B794F4',
    [SurveyQuestionType.SHORT_TEXT]: '#63B3ED',
    [SurveyQuestionType.LONG_TEXT]: '#63B3ED',
    [SurveyQuestionType.DATE]: '#63B3ED',
    [SurveyQuestionType.NUMBER]: '#63B3ED',
    [SurveyQuestionType.CHECKLIST]: '#ECC94B',
    [SurveyQuestionType.LEGAL]: '#90CDF4',
    [SurveyQuestionType.UPLOAD_MEDIA]: '#48BB78',
    [SurveyQuestionType.END_SCREEN]: '#F6AD55',
};

const SURVEY_QUESTION_TYPE_ICONS: Record<SurveyQuestionType, SvgIconComponent> = {
    [SurveyQuestionType.WELCOME]: OndemandVideoIcon,
    [SurveyQuestionType.GENERIC_SCORE]: LinearScaleIcon,
    [SurveyQuestionType.GENERIC_STARS]: StarIcon,
    [SurveyQuestionType.MULTIPLE_CHOICE]: CheckBoxOutlineBlankIcon,
    [SurveyQuestionType.PICTURE_CHOICE]: ImageIcon,
    [SurveyQuestionType.DROPDOWN]: ArrowDropDownCircleIcon,
    [SurveyQuestionType.YES_NO]: ToggleOnIcon,
    [SurveyQuestionType.SHORT_TEXT]: ShortTextIcon,
    [SurveyQuestionType.LONG_TEXT]: TextFieldsIcon,
    [SurveyQuestionType.DATE]: CalendarMonthIcon,
    [SurveyQuestionType.NUMBER]: PinIcon,
    [SurveyQuestionType.CHECKLIST]: ChecklistIcon,
    [SurveyQuestionType.LEGAL]: GavelIcon,
    [SurveyQuestionType.UPLOAD_MEDIA]: CloudUploadIcon,
    [SurveyQuestionType.END_SCREEN]: CelebrationIcon,
};

const SURVEY_QUESTION_TYPE_LABEL_KEYS: Record<SurveyQuestionType, string> = {
    [SurveyQuestionType.WELCOME]: 'Welcome screen',
    [SurveyQuestionType.GENERIC_SCORE]: 'Score 1-10',
    [SurveyQuestionType.GENERIC_STARS]: 'Stars 1-5',
    [SurveyQuestionType.MULTIPLE_CHOICE]: 'Multiple choice',
    [SurveyQuestionType.PICTURE_CHOICE]: 'Picture choice',
    [SurveyQuestionType.DROPDOWN]: 'Dropdown',
    [SurveyQuestionType.YES_NO]: 'Yes / no',
    [SurveyQuestionType.SHORT_TEXT]: 'Short text',
    [SurveyQuestionType.LONG_TEXT]: 'Long text',
    [SurveyQuestionType.DATE]: 'Date',
    [SurveyQuestionType.NUMBER]: 'Number',
    [SurveyQuestionType.CHECKLIST]: 'Checklist',
    [SurveyQuestionType.LEGAL]: 'Legal consent',
    [SurveyQuestionType.UPLOAD_MEDIA]: 'File upload',
    [SurveyQuestionType.END_SCREEN]: 'End screen',
};

const FALLBACK_COLOR = '#A0AEC0';

export const getSurveyQuestionTypeColor = (type: SurveyQuestionType | undefined) => (
    type ? SURVEY_QUESTION_TYPE_COLORS[type] ?? FALLBACK_COLOR : FALLBACK_COLOR
);

export const getSurveyQuestionTypeLabelKey = (type: SurveyQuestionType | undefined) => (
    type ? SURVEY_QUESTION_TYPE_LABEL_KEYS[type] ?? 'Question' : 'Question'
);

export const getSurveyQuestionTypeIcon = (type: SurveyQuestionType | undefined, fontSize: number = 20) => {
    const Icon = (type && SURVEY_QUESTION_TYPE_ICONS[type]) || HelpOutlineIcon;
    return <Icon sx={{color: getSurveyQuestionTypeColor(type), fontSize}}/>;
};
